/* eslint-disable import/prefer-default-export */
import React from "react";
import { startCase } from "lodash";
import { Box, Tab, Tabs } from "@mui/material";

import Panel from "../../../../components/Panel";
import { ClientSettings } from "./ClientSettings";
import SettingsButton from "../../../../components/SettingsButton/SettingsButton";
import { GlobalSettings } from "../GlobalSettings/GlobalSettings";

interface Props {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  renderSettingButton?: boolean;
}

const TABS = {
  CLIENT_SETTINGS: "clientSettings",
  COMMON_SETTINGS: "globalSettings"
};

export const ClientSettingsPanel = ({
  open,
  onOpenChange,
  renderSettingButton = true
}: Props): React.ReactNode => {
  const [internalOpen, setInternalOpen] = React.useState(false);
  const [selectedTab, setSelectedTab] = React.useState(TABS.CLIENT_SETTINGS);

  const isControlled = typeof open === "boolean";
  const actualOpen = isControlled ? open : internalOpen;

  const setOpen = (value: boolean): void => {
    if (isControlled) {
      onOpenChange?.(value);
    } else {
      setInternalOpen(value);
    }
  };

  return (
    <>
      {renderSettingButton && <SettingsButton onClick={() => setOpen(!actualOpen)} />}

      {actualOpen && (
        <Panel
          onClose={() => setOpen(false)}
          title="Client Settings"
          contentStyle={{ height: "calc(100vh - 50px)", py: 0 }}
        >
          <Box sx={{ borderLeft: 1, borderRight: 1, borderColor: "divider" }}>
            <Tabs
              value={selectedTab}
              onChange={(_, newValue) => setSelectedTab(newValue)}
              sx={{
                height: "50px",
                borderBottom: 1,
                borderColor: "divider"
              }}
            >
              <Tab label={startCase(TABS.CLIENT_SETTINGS)} value={TABS.CLIENT_SETTINGS} />
              <Tab label={startCase(TABS.COMMON_SETTINGS)} value={TABS.COMMON_SETTINGS} />
            </Tabs>

            <Box sx={{ height: "calc(100vh - 100px)", p: 2, overflowY: "auto" }}>
              {selectedTab === TABS.CLIENT_SETTINGS && <ClientSettings />}
              {selectedTab === TABS.COMMON_SETTINGS && <GlobalSettings />}
            </Box>
          </Box>
        </Panel>
      )}
    </>
  );
};
